import { NgClass } from '@angular/common'
import { Component, input, signal } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { BndButton } from '@bonduelle-it/storybook'

@Component({
  selector: 'app-menu-overlay',
  templateUrl: './menu-overlay.component.html',
  styleUrls: ['./menu-overlay.component.scss'],
  imports: [MatIconModule, BndButton, NgClass],
})
export class MenuOverlayComponent {
  readonly large = input<boolean>(false)
  public readonly open = signal(false)

  public show() {
    this.open.set(true)
  }

  public hide() {
    this.open.set(false)
  }

  public toggle() {
    this.open.update((open) => !open)
  }
}
